"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrevious = void 0;
const react_1 = require("react");
/**
 * Retains the previous value of provided param.
 * Ref: https://davidwalsh.name/react-useprevious-hook
 */
const usePrevious = value => {
  const ref = (0, react_1.useRef)();
  (0, react_1.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
exports.usePrevious = usePrevious;